import { Navigate, useLocation } from "react-router-dom";

export function AuthGuard({ children, redirect = true }: any) {
  useLocation(); // force the layout to rerender on navigation

  const loggedIn = localStorage.getItem("auth");
  if (loggedIn) return children;
  else return redirect ? <Navigate to="/login" replace={true} /> : null;
}
